<template lang="pug">
	.chart-footer-select-container
		.selectionTrigger(@click='selectItem')
			b-img.hamburger(:src='require("@/assets/svgs/hamburger.svg")')
		.contentSelection {{ selectionValue }}
		.content {{ selectionName }}
</template>

<style lang="scss" scoped>
	.chart-footer-select-container {
		width: 100vw;
		height:100%;
		margin-right:1vw;
		float:right;
			.content {
				float:right;
				margin: 1%;
				font-size: 5 vmin;
				font-weight: 600;
			}
			.contentSelection {
				float:right;
				color: #888;
				margin: 1% 5% 1% 1%;
				font-size: 5 vmin;
				font-weight: 600;
			}
			.selectionTrigger {
				float:right;
				margin: 1%;
				cursor:pointer;
				font-size: 5 vmin;
				font-weight: 600;
				.hamburger {
					width:5 vmin;
					color: #5a726a;
					margin-right: 0;
					margin-left: auto;
				}
			}
	}
</style>

<script>
export default {
	name       : 'chartFooterSelect',
	components : {  },
	props : {
		chartData: {
			type: Object,
		},
		selectedItem: {
			type: [String, Number]
		}
	},
	data : () => ( {

	} ),
	computed : {
		selectionName() {
			let name = 'No Selection';
			if ( 'selectLabel' in this.chartData ) {
				name = `Select ${this.chartData.selectLabel}`;
			}
			return name;
		},
		selections() {
			return this.chartData.chartItems.map( obj => obj.selectValue);
		},
		selectionValue() {
			return this.selections[this.selectedItem];
		}
	},
	created() {

	},
	methods : {
		selectItem() {
			this.$emit('selectChart');
		}
	},

};
</script>
